import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import styles from "./Tooltip.module.scss";
import { MatchObject } from "@/components/pages/tool-components/shared/editor/helpers";

type TooltipProps = {
  htmlId: string;
  x: number | null;
  y: number | null;
  data?: MatchObject;
  ignoreHandler: (matchId: string) => void;
  replaceHandler: (matchId: string, replacement: string) => void;
};

export const Tooltip = ({ x, y, data, htmlId, ignoreHandler, replaceHandler }: TooltipProps) => {
  const [coords, setCoords] = useState({ x, y });
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const toolitpElement = tooltipRef.current;
    if (!toolitpElement) return;
    const elementSizes = toolitpElement.getBoundingClientRect();
    const { clientWidth } = document.documentElement;
    const newCoords: { x?: number; y?: number } = {};

    if (Number(x) + elementSizes.width > clientWidth) newCoords.x = clientWidth - elementSizes.width - 10;

    setCoords((c) => ({ ...c, ...newCoords }));
  }, [x, y]);

  return (
    <div
      className={classNames(styles.tooltip)}
      id={htmlId}
      ref={tooltipRef}
      style={{ top: Number(coords.y), left: Number(coords.x) }}
    >
      <div className={styles.data}>
        <p className={styles.message}>{data?.message}</p>
        {data?.description && <p className={styles.description}>{data.description}</p>}
        <div className={styles.replacements}>
          {data?.replacements?.slice(0, 3).map((replacement, i) => (
            <p key={i} onClick={() => replaceHandler(String(data?.id), replacement.value)}>
              {replacement.value}
            </p>
          ))}
        </div>
      </div>
      <div className={styles.nav}>
        <button className={styles.ignoreBtn} onClick={() => ignoreHandler(String(data?.id))}>
          Ignore this error
        </button>
      </div>
    </div>
  );
};
